import React from 'react';
import Close from './Close';
import AlertMessage from './AlertMessage';
import AlertIcon from './AlertIcon';

import './Alert.scss';

export interface IAlert {
  className?: string;
  close?: boolean;
  level: 'danger' | 'info' | 'success' | 'warning';
  message: any;
  onClickClose?: (...args: any[]) => any;
}

const Alert = (props: IAlert) => {
  const { level, message, className, close, onClickClose } = props;

  return (
    <div className={`pxl-alert pxl-alert--${level} ${className}`}>
      <AlertIcon level={level} />
      <AlertMessage msg={message} />
      <Close onClick={onClickClose} close={close} />
    </div>
  );
};

export default Alert;
